import React, { useEffect, useState } from "react";
import {
  Paper,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
} from "@mui/material/";
import { Link, useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import { ToastManager } from "../../../common/ToastContainer";
import FullPageProgress from "../../../common/FullPageProgress";
import { SESSION_AUTH } from "../../../../helpers/auth";
import EventOrgazinationTeamAdd from "./EventOrgazinationTeamAdd";
import EventOrgazinationTeamRemove from "./EventOrgazinationTeamRemove";
import EventOrgazinationTeamRole from "./EventOrgazinationTeamRole";
import { getModuleAllPermissions } from "../../../../helpers/utils";

const EventOrgazinationTeams = (props) => {
  const { module } = props;
  const [loader, setLoader] = useState(false);
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState("");
  const [profileData, setProfileData] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const { accountId } = useParams();
  const [modulePermissions, setModulePermissions] = useState("");

  useEffect(() => {
    if (userSession) {
      setModulePermissions(getModuleAllPermissions(userSession, module));
      setUserData(userSession);
    } else {
      setModulePermissions("");
      setUserData("");
    }
    return () => null;
  }, [userSession, module]);

  useEffect(() => {
    if (!userData || !accountId || dataFetched || !modulePermissions?.view)
      return;
    setDataFetched(true);
    setLoader(true);
    let parma = {};
    parma["userId"] = userData.userId;
    parma["id"] = accountId;

    EVENTS_SERVICES.getOrgTeams(parma)
      .then((data) => {
        if (data.code === 200) {
          setProfileData(data?.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [
    accountId,
    userData,
    dataFetched,
    modulePermissions,
    LOGOUT_USER_SESSION,
  ]);
  return (
    <>
      {modulePermissions?.add && (
        <div className="managepro6ix-layout-page-content-header pt-0">
          <div className="managepro6ix-layout-page-content-header-action">
            <EventOrgazinationTeamAdd
              onUpdate={() => {
                setDataFetched(false);
              }}
            />
          </div>
        </div>
      )}
      {loader && <FullPageProgress />}

      {profileData ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {profileData &&
                profileData?.map((item, key) => {
                  return (
                    <TableRow key={key}>
                      <TableCell>{key + 1}</TableCell>
                      <TableCell>
                        <Link
                          to={`${process.env.REACT_APP_EVENT_PLATFORM}/u/${item?.userId?.username}`}
                          target="_blank"
                          className="text-link"
                        >
                          <b> {item?.userId?.name} </b>({item?.userId?.email})
                        </Link>
                      </TableCell>
                      <TableCell className="text-status">
                        {item?.role}
                      </TableCell>
                      <TableCell>
                        {!item?.isOwner && modulePermissions?.add ? (
                          <>
                            <EventOrgazinationTeamRemove
                              member={item}
                              onUpdate={() => {
                                setDataFetched(false);
                              }}
                            />
                            <EventOrgazinationTeamRole
                              member={item}
                              onUpdate={() => {
                                setDataFetched(false);
                              }}
                            />
                          </>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </>
  );
};

export default EventOrgazinationTeams;
